import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

const CollaboratorsStats = () => {
  const [topCollaborators, setTopCollaborators] = useState([]);
  const [projectsData, setProjectsData] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    const fetchStats = async () => {
      try {
        // Fetch both projects and collaborators data concurrently
        const [projectsRes, collaboratorsRes] = await Promise.all([
          axios.get("/project", { headers: { Authorization: `Bearer ${token}` } }),
          axios.get("/collaborator", { headers: { Authorization: `Bearer ${token}` } }),
        ]);

        const projects = projectsRes.data;
        const collaborators = collaboratorsRes.data;

        // Populate Top 5 Most Active Collaborators chart
        // This logic is correct as it stands
        const top = [...collaborators]
          .sort((a, b) => (b.projects?.length || 0) - (a.projects?.length || 0))
          .slice(0, 5)
          .map((c) => ({ name: c.name, activityScore: c.projects?.length || 0 }));
        setTopCollaborators(top);

        // Populate Collaborators per Project chart
        // This is the corrected section. We map over the projects data,
        // and ensure the keys match what the chart components expect.
        const proj = [...projects].map((p) => ({
          projectName: p.projectName, // The property on your Project entity is 'projectName'
          collaboratorsCount: p.collaborators?.length || 0, // Count the collaborators from the eager-loaded array
        }));
        setProjectsData(proj);

      } catch (err) {
        console.error("Error fetching stats:", err);
        // Handle the error state in your UI, e.g., by setting an error state
        // and displaying a message to the user.
      }
    };

    fetchStats();
  }, []); // The empty dependency array ensures this effect runs only once

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "40px" }}>
      {/* Top 5 Most Active Collaborators Chart */}
      <div style={{ flex: "0 0 33.333%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <ResponsiveContainer width="90%" height={230}>
          <BarChart data={topCollaborators} margin={{ top: 10, right: 20, left: 20, bottom: 40 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" type="category" tick={{ fontSize: 10, angle: -30, textAnchor: "end" }} />
            <YAxis type="number" tick={{ fontSize: 10 }} />
            <Tooltip />
            <Bar dataKey="activityScore" fill="#22c55e" barSize={24} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Collaborators per Project Chart */}
      <div style={{ flex: "0 0 33.333%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <ResponsiveContainer width="90%" height={230}>
          <BarChart data={projectsData} margin={{ top: 10, right: 20, left: 20, bottom: 40 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="projectName" type="category" tick={{ fontSize: 9, angle: -45, textAnchor: "end" }} />
            <YAxis type="number" tick={{ fontSize: 10 }} />
            <Tooltip />
            <Bar dataKey="collaboratorsCount" fill="#2563eb" barSize={24} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CollaboratorsStats;